module.exports = __webpack_public_path__ + "media/images/app_icons/icon-320x320-ef4537e870c4e02e61f5781080cd560b.png";